<template>
  <v-switch
    v-model="readFilter"
    :label="$t('chat.filterRead')"
  ></v-switch>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-readFilter',
  computed: {
    ...mapGetters({
      read: 'chat/DmFilters/read'
    }),
    readFilter: {
      get () { return this.read },
      set (read) { this.setRead(read) }
    }
  },
  methods: {
    ...mapActions({
      setRead: 'chat/DmFilters/filterRead'
    })
  }
}
</script>

<style>

</style>
